export const matchesContent = (query, values) => {
  const fold = (value) => String(value ?? "").toLocaleLowerCase("fi-FI").normalize("NFC");
  const haystack = values.map(fold).join(" ");
  return fold(query).trim().split(/\s+/).every((word) => haystack.includes(word));
};
